import { useLayoutEffect, useState} from 'react'


interface Size {
    readonly width: number;
    readonly height: number;
}


export function useElementSize(element: HTMLElement | null) {
    const [size, setSize] = useState<Size | null>(null)

    useLayoutEffect(() => {
        if(!element) return

        const updateSize = () => {
            const {width, height} = element.getBoundingClientRect()

            setSize((prevSize) =>
                prevSize &&
                width === prevSize.width &&
                height === prevSize.height
                    ? prevSize // Return stable object if no changes
                    : {width, height}
            )
        }

        updateSize()

        const observer = new ResizeObserver(updateSize)
        observer.observe(element)

        return () => observer.disconnect()
    }, [element])

    return size
}

